module.exports = __webpack_public_path__ + "static/media/Mapa-Amazonas.566d326c.svg";